import React from 'react'
import dataScience from "../../../images/students/data-science.webp";
import ai from "../../../images/students/ai.webp";
import uiUx from "../../../images/students/ui.webp";
import devops from "../../../images/students/devops.webp";
import testing from "../../../images/students/testing.webp";
import digitalMarketing from "../../../images/students/digital-marketing.webp";
import analytics from "../../../images/students/analytics.webp";
import vlsi from "../../../images/students/vlsi.webp";
import mechanical from "../../../images/students/mechanical.webp";
import civilCad from "../../../images/students/civil-cad.webp";
import fullStack from "../../../images/students/full-stack.webp";
import entrepreneurship from "../../../images/students/entrepreneurship.webp";

export default function Pathway() {
    const list = [
        { image: dataScience, name: "DATA SCIENCE", color: "#FC15151A" },
        { image: ai, name: "GENAI & FULL STACK", color: "#FAA4101A" },
        { image: uiUx, name: "UI/UX", color: "#DEE6001A" },
        { image: devops, name: "DEVOPS", color: "#39F5001A" },
        { image: testing, name: "TESTING", color: "#0093A61A" },
        { image: digitalMarketing, name: "DIGITAL MARKETING", color: "#2BBFFF1A" },
        { image: analytics, name: "ANALYTICS", color: "#3997F61A" },
        { image: vlsi, name: "VLSI", color: "#1500D01A" },
        { image: mechanical, name: "MECHANICAL", color: "#FFEED8" },
        { image: civilCad, name: "CIVIL CAD", color: "#7400E71A" },
        { image: fullStack, name: "JAVA FULL STACK", color: "#FF2D551A" },
        { image: entrepreneurship, name: "ENTREPRENEURSHIP", color: "#A2845E1A" }
    ]
    return (
        <div className='mb-[20px] sm:mb-[50px] xl:mb-[70px] p-[20px] relative z-0 w-full overflow-hidden text-center'>
            <h3 className='text-[#101828] text-[24px] md:text-[54px] font-semibold'>Career Pathways</h3>
            <p className='mt-[5px] md:mt-[10px] text-[#7D7F81] font-normal text-[14px] md:text-[25px]'>Each Surge Sunday features a different founder or operator who has:</p>
            <div className='mt-[20px] md:mt-[48px] flex gap-[15px] md:gap-[20px] flex-wrap justify-center items-center md:w-11/12 mx-auto text-[#1E2939] text-[14px] md:text-[23px] font-semibold'>
                {list.map((item, index) => (
                    <div key={index} className='w-[150px] h-[168px] md:w-[220px] md:h-[258px] rounded-[8px] md:rounded-[16px] border border-[#E5E7EB] text-center p-[14px] md:p-[28px]' style={{ background: item?.color }}>
                        <img src={item?.image} alt='data' className='mx-auto size-[110px] md:size-[155px]' />
                        <p className='mt-[14px] md:mt-[18px] text-[#1E2939] font-bold text-[10px] md:text-[18px]'>{item?.name}</p>
                    </div>
                ))}
            </div>
        </div>
    )
}
